"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.aspendentalPalette = exports.palette = void 0;
var palette_1 = require("../../shared/palette");
exports.palette = {
    primary: {
        '100': '#E5E9EE',
        '300': '#B3BFCC',
        '500': '#002855',
        '700': '#002044',
        '900': '#001833',
    },
    secondary: {
        '100': '#E5EDF8',
        '300': '#B3C9EA',
        '500': '#004BB9',
        '700': '#003C94',
        '900': '#002D6F',
    },
    tertiary: {
        '100': '#E5EDF8',
        '300': '#B3C9EA',
        '500': '#004BB9',
        '700': '#003C94',
        '900': '#002D6F',
    },
    neutrals: __assign(__assign({}, palette_1.commonNeutrals), { '500': '#A7ADB0', '700': '#696E72' }),
    text: __assign({}, palette_1.commonTextColors),
    accent01: __assign(__assign({}, palette_1.commonAccent01), { '100': '#E5EDF8', '300': '#B3C9EA', '500': '#004BB9', '700': '#003C94', '900': '#002D6F' }),
    accent02: __assign(__assign({}, palette_1.commonAccent02), { '100': '#E7FBF6', '300': '#BAF4E6', '500': '#18D9AB', '700': '#13AE89', '900': '#0E8267' }),
    accent03: __assign(__assign({}, palette_1.commonAccent02), { '100': '#E7FBF6', '300': '#BAF4E6', '500': '#18D9AB', '700': '#13AE89', '900': '#0E8267' }),
    accent04: __assign(__assign({}, palette_1.commonAccent02), { '100': '#E7FBF6', '300': '#BAF4E6', '500': '#18D9AB', '700': '#13AE89', '900': '#0E8267' }),
    success: __assign(__assign({}, palette_1.commonSuccess), { '700': '#027356' }),
    error: __assign({}, palette_1.commonError),
    warning: __assign({}, palette_1.commonWarning),
    info: __assign({}, palette_1.commonInfo),
    background: __assign(__assign(__assign({}, palette_1.commonBackgroundColors), palette_1.commonGradients), { lightTwo: '#E5F2FF', lightThree: '#E5F2FF', dark: '#002855', darkTwo: '#002855', neutralGradient: 'linear-gradient(180deg, #EEEFF0 0%, #F5F6F7 70%)', lightGradient: 'linear-gradient(180deg, #CEE0F2 0%, #DEEEFF 100%)', lightTwoGradient: 'linear-gradient(180deg, #CEE0F2 0%, #DEEEFF 100%)', lightThreeGradient: 'linear-gradient(180deg, #CEE0F2 0%, #DEEEFF 100%)', darkGradient: 'linear-gradient(165deg, #0C3867 4.91%, #125399 89.46%)', ODPHeroGradient: 'linear-gradient(97deg, rgba(0, 40, 85, 0.85) 33.86%, rgba(0, 40, 85, 0.00) 73.68%)', teamTagBrandColor: '#2288C9' }),
};
exports.aspendentalPalette = {
    primary: {
        lightest: exports.palette.primary[100],
        light: exports.palette.primary[300],
        main: exports.palette.primary[500],
        dark: exports.palette.primary[700],
        darkest: exports.palette.primary[900],
    },
    secondary: {
        lightest: exports.palette.secondary[100],
        light: exports.palette.secondary[300],
        main: exports.palette.secondary[500],
        dark: exports.palette.secondary[700],
        darkest: exports.palette.secondary[900],
    },
    tertiary: {
        lightest: exports.palette.tertiary[100],
        light: exports.palette.tertiary[300],
        main: exports.palette.tertiary[500],
        dark: exports.palette.tertiary[700],
        darkest: exports.palette.tertiary[900],
    },
    neutrals: {
        white: exports.palette.neutrals.white,
        neutral: exports.palette.neutrals[100],
        primary: exports.palette.neutrals[300],
        disabled: exports.palette.neutrals[500],
        secondary: exports.palette.neutrals[900],
        tertiary: exports.palette.neutrals[700],
    },
    text: {
        primary: exports.palette.text.primary,
        secondary: exports.palette.text.secondary,
        tertiary: exports.palette.text.tertiary,
        light: exports.palette.text.light,
        disabled: exports.palette.text.disabled,
        interactive: exports.palette.text.interactive,
    },
    accent01: {
        lightest: exports.palette.accent01[100],
        light: exports.palette.accent01[300],
        main: exports.palette.accent01[500],
        dark: exports.palette.accent01[700],
        darkest: exports.palette.accent01[900],
    },
    accent02: {
        lightest: exports.palette.accent02[100],
        light: exports.palette.accent02[300],
        main: exports.palette.accent02[500],
        dark: exports.palette.accent02[700],
        darkest: exports.palette.accent02[900],
    },
    accent03: {
        lightest: exports.palette.accent03[100],
        light: exports.palette.accent03[300],
        main: exports.palette.accent03[500],
        dark: exports.palette.accent03[700],
        darkest: exports.palette.accent03[900],
    },
    accent04: {
        lightest: exports.palette.accent04[100],
        light: exports.palette.accent04[300],
        main: exports.palette.accent04[500],
        dark: exports.palette.accent04[700],
        darkest: exports.palette.accent04[900],
    },
    success: {
        light: exports.palette.success[300],
        main: exports.palette.success[500],
        dark: exports.palette.success[700],
    },
    error: {
        light: exports.palette.error[300],
        main: exports.palette.error[500],
        dark: exports.palette.error[700],
    },
    warning: {
        light: exports.palette.warning[300],
        main: exports.palette.warning[500],
        dark: exports.palette.warning[700],
    },
    info: {
        light: exports.palette.info[300],
        main: exports.palette.info[500],
        dark: exports.palette.info[700],
    },
    backgrounds: __assign({}, exports.palette.background),
};
